import { ol as flatGeobufOL } from 'flatgeobuf'
import OLFormatGeoJSON from 'ol/format/GeoJSON'
import * as loadingStrategy from 'ol/loadingstrategy.js'
import { transformExtent as OLProjTransformExtent } from 'ol/proj'
import OLSourceVector from 'ol/source/Vector'

import type { ConfigLayerOptions } from './ConfigLayer'
import type OLFeature from 'ol/Feature'

import PoziAPIData from 'api/data'
import { convertOLFeatureArrToTurfFeature } from 'api/utils'
import { setLayerLoadDone, setLayerLoadFailed, setLayerLoadInProgress } from 'drawer/tabs/layers/actions'

import LoaderHandleGeoJSON from './LoaderHandleGeoJSON'

export default function (layerConf: ConfigLayerOptions) {
  const { titleid } = layerConf

  console.debug('LoaderFlatGeobuf', titleid)

  const url = layerConf?.config?.spatial?.url
  if (!url) {
    console.log('LoaderFlatGeobuf: no url provided in layer config.')
    return
  }

  const dataProjection = layerConf?.config?.spatial?.projection || layerConf?.config?.projection || 'EPSG:4326'

  // Some type of FGB calls require an extent. We create a world extent in this case
  const worldExtent = [-20037508.34, -20048966.1, 20037508.34, 20048966.1]
  const worldExtent4326 = OLProjTransformExtent(worldExtent, 'EPSG:3857', 'EPSG:4326')
  // console.debug('LoaderFlatGeobuf: world extent', worldExtent4326)

  const source = new OLSourceVector({
    format: new OLFormatGeoJSON(),
    loader: async function (ext, resolution, projection, success, failure) {
      const [minX, minY, maxX, maxY] = worldExtent4326

      // Convert to FB extent
      const fgExtent = {
        minX,
        minY,
        maxX,
        maxY
      }

      // const timerName = 'flatgeobuf_' + layerConf.titleid
      // console.time(timerName)

      try {
        const features: OLFeature[] = []

        // OL Load BBOX strategy:
        //
        // const fgFeatures = flatGeobufOL.deserialize(url, fgExtent) // suspended results

        // Generic loading:
        //
        // const fgGeneric = flatGeobufGeneric.deserialize(url)
        // console.log('flatgeobuf generic', fgGeneric, flatGeobufGeneric)
        // @ts-ignore
        // for await (const feature of fgGeneric) {
        //   console.log('LoaderFlatGeobuf - generic', feature)
        // }

        // const fgResponse = await flatGeobufGeoJSON.deserialize(response.body || '', undefined, (header) => (headerMeta = header))
        // console.log('flatgeobuf geojson', fgResponse, headerMeta)

        // @ts-ignore
        // for await (const feature of fgResponse) {
        //   console.log('LoaderFlatGeobuf - geojson', feature)
        // }

        // OL Load ALL strategy (suspended):
        //
        // Note: this does not work with other CRSs yet
        //
        // const fgFeatures = flatGeobufOL.deserialize(url, fgExtent) // suspended results

        // OL preload features:
        //
        // Note: this works with other CRSs
        //

        let fgFeatures: OLFeature<Geometry>[] | AsyncGenerator<OLFeature<Geometry>, any, unknown>

        // const fetchResponse = (await fetch(url)).body
        // console.log('LoaderFlatGeobuf  fetch', typeof fetchResponse, fetchResponse)
        // fgFeatures = flatGeobufOL.deserialize(fetchResponse || '')

        try {
          // jQuery AJAX call (much more convoluted than fetch)
          const response = await PoziAPIData().ajax({
            dataType: 'binary',
            url,
            xhrFields: {
              responseType: 'blob'
            }
          })

          // Convert Blob to Uint8Array so flatgeobuf can read our response
          const responseAsArrayBuffer = await new Response(response).arrayBuffer()
          const responseAsUint8Array = new Uint8Array(responseAsArrayBuffer)

          fgFeatures = flatGeobufOL.deserialize(responseAsUint8Array)
        } catch (error) {
          console.log('LoaderFlatGeobuf - unexpected error requesting/parsing URL', titleid, url, error)

          if (failure) {
            failure()
          }

          return
        }

        // console.log('LoaderFlatGeobuf - features', fgFeatures)

        // @ts-ignore
        for await (const feature of fgFeatures) {
          // console.debug('LoaderFlatGeobuf - feature', feature)

          // @ts-ignore

          const geom = feature.getGeometry()
          if (geom) {
            geom.transform(dataProjection, 'EPSG:3857')
          }

          // add each feature to the map, after projecting it to
          // // @ts-expect-error
          features.push(feature)

          // Add features individually: slower but with visual progress
          // @ts-ignore
          // this.addFeature(feature)

          // console.log('LoaderFlatGeobuf - feature', feature)
        }

        // console.debug('LoaderFlatGeobuf - features', features)

        const geojson = convertOLFeatureArrToTurfFeature(features)

        // TODO: do not hardcode projection here.
        LoaderHandleGeoJSON(geojson, 'EPSG:4326', this, layerConf, success)

        // console.debug('LoaderFlatGeobuf - geojson', geojson)
      } catch (error) {
        console.log('LoaderFlatGeobuf - error', error)

        if (failure) {
          failure()
        }
      }

      // console.timeEnd(timerName)
    },

    strategy: loadingStrategy.all
  })

  source.on('featuresloadstart', () => {
    // console.debug('LoaderFlatGeobuf - features load start')

    window.store.dispatch(setLayerLoadInProgress(layerConf.titleid))
  })
  source.on('featuresloadend', () => {
    // console.debug('LoaderFlatGeobuf - features load end')

    window.store.dispatch(setLayerLoadDone(layerConf.titleid))
  })
  source.on('featuresloaderror', () => {
    // console.debug('LoaderFlatGeobuf - features load error')

    window.store.dispatch(setLayerLoadFailed(layerConf.titleid))
  })

  return source
}
